export const GET_APP_HOST = 'musicapp.amazon.com'

function sessionId(): string {
    return /(?:^|;\s*)session-id\s*=\s*([^;]*)/.exec(document.cookie)?.[1] ?? ''
}

/**
 * A Get App link on musicapp.amazon.com that opens `contentPath` in the app, or the app store when
 * the app is missing; `refMarker` tells BI which button sent the customer and `webSessionId` joins
 * the web session to the install.
 */
export function buildGetAppDeeplink(refMarker: string, contentPath: string): string {
    const url = new URL(contentPath, `https://${GET_APP_HOST}`)
    url.searchParams.set('ref', refMarker)
    url.searchParams.set('webSessionId', sessionId())
    return url.toString()
}
